<template>
  <v-app-bar app fixed clipped-left>
    <v-app-bar-nav-icon
      class="d-none d-md-block d-lg-none"
      @click.stop="$emit('drawer:toggle')"
    ></v-app-bar-nav-icon>

    <div class="d-flex align-center">

      <v-img
        v-if="this.isMobile || this.$vuetify.breakpoint.smAndDown"
        alt="servicio Andaluz Salud Logo"
        class="shrink mr-2 cursor--point logo__movil--sas"
        contain
        src="@/assets/logo_pequeno_junta_andalucia.jpg"
        transition="scale-transition"
        :width="24"
        @click="maybeGoToHome()"
      />

      <div
        :style="{
          display: 'flex',
          marginLeft: '1rem',
          marginRight: '1.5rem',
        }">
        <img
          v-if="!this.$vuetify.breakpoint.smAndDown"
          class="cursor--point"
          alt="Junta de Andalucia"
          :style="{maxWidth: '43px'}"
          src="https://www.sspa.juntadeandalucia.es/servicioandaluzdesalud/ayudadigital/sites/default/files/repositorio/2025-11/logo-junta.svg"
          :width="$vuetify.breakpoint.smAndDown ? 110 : 190"
          @click="maybeGoJunta()"
        />
        <img
          v-if="!this.$vuetify.breakpoint.smAndDown"
          class="cursor--point"
          alt="Junta de Andalucia"
          :style="{maxWidth: '150px', width: '115px', marginLeft: '8px'}"
          src="https://www.sspa.juntadeandalucia.es/servicioandaluzdesalud/ayudadigital/repositorio/logotipo-sas"
          :width="$vuetify.breakpoint.smAndDown ? 110 : 190"
          @click="maybeGoSAS()"
        />
      </div>

      <v-img
        v-if="!this.isMobile"
        alt="Ayuda Digital Logo"
        class="shrink mr-2 cursor--point"
        contain
        src="@/assets/logo_large.png"
        :width="$vuetify.breakpoint.smAndDown ? 110 : 190"
        @click="maybeGoToAyudaDigital()"
      />
    </div>
    <v-spacer></v-spacer>

    <SessionTimeoutWarning
    :openSessionTimeoutWarning="openSessionTimeoutWarning"
    @closeSessionTimeoutWarning="openSessionTimeoutWarning = $event"
    @sessionLogout="logout">
    </SessionTimeoutWarning>

    <v-tooltip
      :key="'icon-ayudadigital-pulsodigital-negativo'"
      :disabled="false"
      bottom
    >
      <template v-slot:activator="{  on }">
        <v-btn
          v-if="!isCitizen() && !onlyAccessPulso"
          class="primary--text"
          text
          icon
          to="/pulsodigital"
          v-on="on"
        >
          <v-icon id="pulsoDigitalBtn">icon-ayudadigital-pulsodigital-negativo</v-icon>
        </v-btn>
      </template>
      <span >Pulso Digital</span>
    </v-tooltip>

    <!-- Notification Dropdown Menu-->
    <NotificationMenu
      v-if="!isCitizen() && !onlyAccessPulso"
      :displayWelcomeNews="$store.getters['globalState/get']('display_welcome_news')"
      :showNews="(!openSearchTextMobile && $vuetify.breakpoint.mdAndUp
      && !isCitizen() && isLoginAccess())"
    />

    <v-snackbar
      v-model="snackbar"
      bottom
      color="amber accent-4"
      multi-line
      timeout="3000"
    >
      {{ $t(`navbar.errors.portalcges`) }}
    </v-snackbar>

    <!-- User profile options -->
    <navbar-section
      v-if="!openSearchTextMobile  && !onlyAccessPulso"
      id="userIcon"
      :iconTour="'perfilBtn'"
      :icon="this.nameUser"
      tooltip="Perfil"
      :iconText="true"
    >
      <card-popup :viewMoreLink="false" :items="userProfileSettings">
        <template #item="{ item, idx }">
          <v-list-item :to="item.to">
            <v-list-item-action>
              <v-icon color="primary">{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item>

          <v-divider :key="`${idx}-divider`" />
        </template>
      </card-popup>
    </navbar-section>
    <!-- </template> -->
  </v-app-bar>
</template>

<script>
import { mapState } from 'vuex';
import store from '@/store';
import NavbarSection from '@/components/NavbarSection.vue';
// import Searchbar from '@/components/Searchbar.vue';
/* import News from '@/components/News.vue'; */
// import LastNotificationsPopup from '@/components/LastNotificationsPopup.vue';
import CardPopup from '@/components/CardPopup.vue';
import SessionTimeoutWarning from '@/components/SessionTimeoutWarning.vue';
import NotificationMenu from './NotificationMenu.vue';

export default {
  props: ['drawer'],
  components: {
    CardPopup,
    // LastNotificationsPopup,
    NavbarSection,
    /* News, */
    // Searchbar,
    NotificationMenu,
    SessionTimeoutWarning,
  },
  data: () => ({
    snackbar: false,
    openSearchTextMobile: false,
    lastNotificationsVisible: false,
    newsVisible: false,
    visibleSwitch: true,
    nameUser: '',
    openSessionTimeoutWarning: false,
    onlyAccessPulso: false,
  }),
  computed: {
    ...mapState({
      user: ({ session: { session } }) => (session != null ? session.user : null),
    }),
    isMobile() {
      const getter = this.$store.getters['globalState/get'];
      return getter('deviceOS') != null;
    },
    userProfileSettings() {
      const resourceCi = process.env.VUE_APP_KI_RESOURCE_CI;
      return [
        {
          name: this.user.fullName || this.$t('navbar.profile'),
          icon: 'mdi-account-outline',
          to: '/profile/edit',
          visibility: !this.isCitizen(),
        },
        {
          name: this.$t('navbar.utils'),
          icon: 'mdi-cog',
          to: '/utils',
          visibility: true,
        },
        {
          name: this.$t('navbar.security'),
          icon: 'mdi-security',
          to: '/security',
          visibility: true,
        },
        {
          name: this.$t('navbar.news'),
          icon: 'icon-ayudadigital-estrella-negativa',
          to: '/news',
          visibility: true,
        },
        {
          name: this.$t('navbar.help'),
          icon: 'mdi-help',
          to: `/soluciones/${ resourceCi }`,
          visibility: !this.isCitizen(),
        },
        {
          name: this.$t('navbar.logout'),
          icon: 'mdi-logout',
          to: '/logout',
          visibility: true,
        },
      ].filter((e) => e.visibility === true);
    },
  },
  created() {
    setInterval(this.checkSessionTimeout, this.$getConst('session.timeoutCheck'));
  },
  mounted() {
    const { middleName, name } = this.user;
    this.nameUser = `${middleName ? middleName.charAt(0) : ''} ${name ? name.charAt(0) : ''}`;
    this.newsVisible = this.$store.getters['globalState/get']('display_welcome_news');
    this.onlyAccessPulso = localStorage.getItem('onlyAccessPulso');
  },
  beforeRouteUpdate(to, from, next) {
    const {
      path,
      query: { q },
    } = to;
    if (path === '/search' && (typeof q !== 'string' || q.trim() === '')) {
      this.$refs.searchGeneral.inputValue = '';
    }
    next();
  },
  /* watch: {
    $route(to) {
      const { path, query: { q } } = to;
      if (path === '/search' && (typeof q !== 'string' || q.trim() === '')) {
        this.$refs.searchGeneral.inputValue = '';
      }
    },
  }, */
  methods: {
    targetPortalCges() {
      const currentLocation = document.URL;
      const [
        cgesLocation,
        oldProdLocation,
        currentProdLocation,
        currentPreLocation,
      ] = ['url.cges', 'url.oldProd', 'url.currentProd', 'url.currentPre'].map(
        (key) => this.$getConst(key, ''),
      );
      const local = 'localhost';
      if (
        [oldProdLocation, currentProdLocation, currentPreLocation, local].some(
          (loc) => currentLocation.includes(loc),
        )
      ) {
        window.open(cgesLocation, '_blank');
      } else {
        this.snackbar = true;
      }
    },
    logout() {
      this.$emit('menuitem-logout');
    },
    isCitizen() {
      return this.user.hasIosUser();
    },
    isLoginAccess() {
      return this.$router.currentRoute.path === '/';
    },
    modalSurvey() {
      this.$emit('menuitem-surveyapp');
    },
    maybeGoToHome() {
      const isMobile = this.$store.getters['globalState/get']('deviceOS') != null;
      if (isMobile === true) {
        this.$router.push('/');
      }
    },
    maybeGoToAyudaDigital() {
      const ayudaDigitalLocation = 'https://www.sspa.juntadeandalucia.es/servicioandaluzdesalud/ayudadigital/';
      window.open(ayudaDigitalLocation, '_blank');
    },
    maybeGoSAS() {
      const servicioAndaluzSalud = 'https://www.sspa.juntadeandalucia.es/servicioandaluzdesalud/';
      window.open(servicioAndaluzSalud, '_blank');
    },
    maybeGoJunta() {
      const servicioAndaluzSalud = 'https://www.juntadeandalucia.es/';
      window.open(servicioAndaluzSalud, '_blank');
    },
    checkSessionTimeout() {
      const sessionTimeout = store.getters['session/sessionTimeout'];
      const date = new Date().getTime();
      if (date - sessionTimeout >= this.$getConst('session.timeoutWarning') && !this.openSessionTimeoutWarning) {
        this.openSessionTimeoutWarning = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .searchbar {
    min-width: 20rem;
    width: 33.3333%;
    margin-right: 3rem;
  }
  .logo__imagen--sas {
    height: 45px;
    top: -4px;
  }
  .logo__movil--sas {
    height: 24px;
  }
  .cursor--point {
    cursor: pointer;
  }
  .v-list-item .v-list-item__title {
    line-height: 1.3;
  }
</style>

<style>
  #userIcon + .v-btn i {
    font-size: 20px !important;
    padding: 1em !important;
    border-radius: 50% !important;
    background-color: #27846d !important;
    color: white !important;
    font-style: normal !important;
  }
</style>
